import { BaseModel } from './base-model';
import { RouteGeometry } from '../models/voyage-routing-model';
import { CrossedGeometry } from '../utils/geometries-intersection';

export interface Properties {
    featureType: featureType;
    catalogueNumber?: string;
    title?: string;
    filename?: string;
    editionNumber?: number;
    editionName?: string;
    editionDate?: string;
    bookCatalogueNumber?: string;
    chapterNumber?: number;
    chapterName?: string;
    firstPageNumber?: number;
    lastPageNumber?: number;
}

export interface EnpFeature extends CrossedGeometry {
    type: string;
    properties: Properties;
}

export interface EnpBookAndChapter {
    type: string;
    name: string;
    date: Date;
    features: EnpFeature[];
}

export type featureType = "Book" | "BookChapter";

export abstract class VesselEnpBookAndChapterModelBase extends BaseModel
{
    abstract get books(): Map<string, EnpFeature> | null;
    abstract get chapters(): EnpFeature[] | null;
    abstract get booksFeatures(): EnpFeature[] | null;
    abstract chaptersCrossedByRoute(routeGeometry: RouteGeometry): Map<string, EnpFeature[]>;
    abstract getCrossedEnpChaptersAndBooks(route: RouteGeometry) : string;
    loadingPromise: Promise<void> | null = null;
}

let VesselEnpBookAndChapterModel: VesselEnpBookAndChapterModelBase|null = null;

function setVesselEnpBookAndChapterModel(model: VesselEnpBookAndChapterModelBase)
{
    VesselEnpBookAndChapterModel = model;
}

export { VesselEnpBookAndChapterModel, setVesselEnpBookAndChapterModel };
